import { FC } from 'react'
import styles from './LegalClientsTable.module.css'
import { ClientsType } from '../../redux/actions/types'
import { useNavigate } from 'react-router-dom'
export type LegalClientsTablePropsType = {
  data?: ClientsType[]
}

const LegalClientsTable: FC<LegalClientsTablePropsType> = ({ data }) => {
  const navigate = useNavigate()

  const legalClients = data?.filter((client) => client.type === 'legal')

  const handleRowClick = (clientId: string) => {
    navigate(`/clients-page?id=${clientId}`)
  }
  return (
    <div>
      <table className={styles.tableContainer}>
        <thead className={styles.tableHeader}>
          <tr className={styles.tableHeaderRow}>
            <th className={styles.headerItem}>ИНН</th>
            <th className={styles.headerItem}>Название Организации</th>
            <th className={styles.headerItem}>Юридический адрес</th>
            <th className={styles.headerItem}>Номер телефона</th>
            <th className={styles.headerItem}>Эл. адрес</th>
          </tr>
        </thead>
        <tbody className={styles.tableBody}>
          {legalClients?.map((client) => (
            <tr
              className={styles.tableBodyRow}
              key={client?.id}
              onClick={() => handleRowClick(String(client?.id))}
            >
              <td className={styles.bodyItem}>{client?.inn || '—'}</td>
              <td className={styles.bodyItem}>{client?.organizationName || '—'}</td>
              <td className={styles.bodyItem}>{client?.legalAddress || '—'}</td>
              <td className={styles.bodyItem}> {client?.contactPhone}</td>
              <td className={styles.bodyItem}>{client?.email}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default LegalClientsTable
